export const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/enrollment", label: "Enrollment" },
  { path: "/rules-protocol", label: "Rules/Protocol" },
  { path: "/graduates", label: "Graduates" },
  { path: "/homework", label: "Homework" },
  { path: "/scoreboard", label: "Scoreboard" },
  { path: "/contact-us", label: "Contact Us" },
];

export const SCORE_COLUMN_MAP = {
  recruit: "Recruit",
  sales: "Sales",
  book: "Book",
  bonusPromo: "Bonus Promo",
  bonusBBC: "Bonus BBC",
  bonusEvents: "Bonus Events",
  bonusBF: "Bonus BF",
  bonusGX: "Bonus GX",
  attend: "Attend",
  penalty: "Penalty",
  penaltyNotes: "Penalty Notes",
  callout: "Callout",
  calloutNotes: "Callout Notes",
  total: "Total",
};
